/**
 * "Your last inspection" (screens/LastInspection.tsx), loaded once for both the /inspection route (App.tsx) and Today's quiet row
 * (`<LastInspectionLazy row />`): one lazy wrapper, so the main chunk carries a single import of the page's chunk.
 */
import { lazyNamed } from "../lib/lazy.ts";

export const LastInspectionLazy = lazyNamed(() => import("./LastInspection.tsx"), "LastInspection");
